import styles from './PartiesPage.module.css';

const galleryImages = Object.values(
  import.meta.glob('@/assets/gallery/*.jpeg', { eager: true, query: '?url', import: 'default' })
) as string[];

function PartiesPage() {
  return (
    <div className={styles.page}>
      <section className={styles.content}>
        <h1 className={styles.title}>Private Parties</h1>
        <article className={styles.description}>
          Make your next private event a memorable one. Beantown Pub offers a variety of spaces
          that are perfect for accommodating small gatherings or corporate events. Choose from
          spaces with single, multiple, or no pool tables. Our private event menu offers a variety
          of freshly prepared delicious appetizers all the way up to a full buffet with several entrees.
        </article>
        <div className={styles.contactBox}>
          <p>
            For more information or to make a reservation, please contact us at{' '}
            <a href="mailto:BeantownPubBoston@gmail.com">BeantownPubBoston@gmail.com</a> or call us at{' '}
            <a href="tel:6174260111">617-426-0111</a>.
          </p>
        </div>
        <div className={styles.gallery}>
          {galleryImages.map((src, i) => (
            <div key={i} className={styles.galleryItem}>
              <img src={src} alt="Beantown Pub private event space" className={styles.galleryImage} />
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default PartiesPage;
